module.exports = __webpack_public_path__ + "static/media/MY-JINYIN.d74add5f.jpg";